module.exports = __webpack_public_path__ + "img/mark_all_read_1.6182da8d.svg";